import { DatePipe, NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AvmEmailAddressesPipe } from '@hub4b/pipes/avm-email-addresses.pipe';
import { DocumentPropertyCodes } from 'src/app/core/constantes/document-property-codes';
import { TableHeaderBaseDirective } from 'src/app/core/directives/table-header-base.directive';
import { AvmDocumentCellPipe } from 'src/app/core/pipes/avm-document-cell.pipe';
import { DateHelper } from 'src/app/helpers/date-helper';
import { ActionType } from 'src/app/models/enums/action-type';
import { CellType } from 'src/app/models/enums/cell-type';
import { DocumentFlux } from 'src/app/models/enums/document-flux';
import { DocumentType } from 'src/app/models/enums/document-type';
import { PropertyType } from 'src/app/models/enums/property-type';
import { ColumnDefinition } from 'src/app/models/server/column-definition';
import { FolderDocument } from 'src/app/models/server/folder-document';

@Component({
    selector: 'app-document-table-cell',
    templateUrl: './document-table-cell.component.html',
    styleUrls: ['./document-table-cell.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgClass, MatIconModule, MatTooltipModule, DatePipe, AvmEmailAddressesPipe, AvmDocumentCellPipe]
})
export class DocumentTableCellComponent extends TableHeaderBaseDirective {
    /**
     * Références des Enums utilisées dans le template.
     */
    public PropertyType = PropertyType;
    public DocumentType = DocumentType;
    public DocumentFlux = DocumentFlux;
    public ActionType = ActionType;
    public CellType = CellType;

    /**
     * Références des constantes utilisées dans le template.
     */
    public FRENCH_DATETIME_FORMAT = DateHelper.FRENCH_DATETIME_FORMAT;
    public TYPE = DocumentPropertyCodes.TYPE;
    public FLUX = DocumentPropertyCodes.FLUX;
    public FROM = DocumentPropertyCodes.FROM;
    public TO = DocumentPropertyCodes.TO;

    /**
     * Type de donnée affiché dans la cellule.
     */
    public cellType: CellType;

    /**
     * Définition de la colonne à laquelle cette cellule appartient.
     */
    private _column: ColumnDefinition;

    /**
     * Spécifie la définition de la colonne à laquelle cette cellule appartient.
     */
    @Input()
    public set column(value: ColumnDefinition) {
        this._column = value;

        if (this.isStandardInputColumn(this._column)) {
            this.cellType = CellType.Standard;
        } else if (this.isEnumInputColumn(this._column)) {
            this.cellType = CellType.Enum;
        } else if (this.isDateInputColumn(this._column)) {
            this.cellType = CellType.Date;
        } else if (this.isDateAndTimeInputColumn(this._column)) {
            this.cellType = CellType.DateAndTime;
        }
    }

    /**
     * Obtient la définition de la colonne à laquelle cette cellule appartient.
     */
    public get column(): ColumnDefinition {
        return this._column;
    }

    /**
     * Instance de la ligne d'historique à afficher dans cette cellule.
     */
    private _data: FolderDocument;

    /**
     * Spécifie l'instance de la ligne d'historique à afficher dans cette cellule.
     */
    @Input()
    public set data(value: FolderDocument) {
        this._data = value;
        this.hasAttachment = (value as any).attachments.filter((x) => x.name !== 'body.txt').length > 0;
    }

    /**
     * Obtient l'instance de la ligne d'historique à afficher dans cette cellule.
     */
    public get data(): FolderDocument {
        return this._data;
    }

    /**
     * Valeur indiquant si le document contient des pièces-jointes.
     */
    public hasAttachment: boolean = false;

    /**
     * Constructeur.
     */
    constructor() {
        super();
    }
}
